import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbDatepickerModule, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: true,
  selector: "app-date-picker",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"],
  imports: [CommonModule, FormsModule, NgbDatepickerModule],
})
export class DatePickerComponent {
  @Input() model: string | null = null; // aaa-mm-dd
  @Output() modelChange = new EventEmitter<string | null>();

  @Input() placeholder = "--/--/----";

  parsedValue: NgbDateStruct | null = null;
  displayValue: string = "";

  ngOnInit() {
    this.syncModel();
  }

  ngOnChanges() {
    this.syncModel();
  }

  private syncModel() {
    if (this.model) {
      const [y, m, d] = this.model.split("-");
      this.parsedValue = { year: +y, month: +m, day: +d };
      this.displayValue = `${this.pad(d)}/${this.pad(m)}/${y}`;
    } else {
      this.parsedValue = null;
      this.displayValue = "";
    }
  }

  onDateSelect(date: NgbDateStruct, datepicker: any) {
    if (
      this.parsedValue &&
      date.year === this.parsedValue.year &&
      date.month === this.parsedValue.month &&
      date.day === this.parsedValue.day
    ) {
      this.clearDate(datepicker);
    } else {
      this.setDate(date);
      datepicker.close();
    }
  }

  clearDate(datepicker?: any) {
    this.parsedValue = null;
    this.displayValue = "";
    this.model = null;
    this.modelChange.emit(this.model);

    if (datepicker) {
      datepicker.close();
    }
  }

  private setDate(date: NgbDateStruct) {
    this.parsedValue = date;
    this.displayValue = `${this.pad(date.day)}/${this.pad(date.month)}/${
      date.year
    }`;
    this.model = `${date.year}-${this.pad(date.month)}-${this.pad(date.day)}`;
    this.modelChange.emit(this.model);
  }

  private pad(n: any): string {
    return `${+n < 10 ? "0" + +n : +n}`;
  }
}
